import "./NursingCareNow.module.css";
import Header from "@/reusable_sections/Header";
import CallToAction from "./sections/CallToAction";
import SpecialExpertise from "./sections/SpecialExpertise";
import TrustAndSecurity from "./sections/TrustAndSecurity";
import CaregiversInCities from "./sections/CaregiversInCities";
import Footer from "@/reusable_sections/Footer";
export default function NursingCareNowPage() {
  return <div>
      <Header />
      <CallToAction />
      <SpecialExpertise />
      <TrustAndSecurity />
      <CaregiversInCities />
      <Footer />
    </div>;
}